namespace GeniuzPOS.Product {
    export class CsTasteColumns {
        static columnsKey = 'Product.CsTaste';
    }
}
